<template>
  <v-dialog max-width="580" v-model="dialog">
    <v-card>
      <v-card-title>
        <v-layout>
          <v-flex> Select Date & Time </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>

        <!-- <v-flex>
          <div>
            Date:
            {{ datePicker }}
          </div>
          <div>Time: {{ timePicker }}</div>
          <div>
            {{ dateStringToDate(datePicker + " " + timePicker) }}
          </div>
        </v-flex> -->
      </v-card-title>
      <v-date-picker v-model="datePicker"></v-date-picker>
      <v-time-picker v-model="timePicker" />
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel</v-btn
        >
        <v-btn
          color="primary"
          class="text-none subtitle-2"
          @click="onDateSelected"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
export default {
  props: {
    date: {
      type: String,
      default: function () {
        return "";
      },
    },
  },
  data() {
    return {
      dialog: false,
      datePicker: "",
      timePicker: "",
    };
  },
  methods: {
    toggleDialog(date) {
      this.dialog = !this.dialog;
      if (this.dialog) {
        console.log(this.iMoment(date, "YYYY-MM-DD"));
        console.log(this.iMoment(date, "HH:mm"));

        this.datePicker = date
          ? this.iMoment(date, "YYYY-MM-DD")
          : this.iMoment(Date(), "YYYY-MM-DD");
        this.timePicker = date
          ? this.iMoment(date, "HH:mm")
          : moment().add(5, "minutes").format("HH:mm");
      }
    },
    iMoment(date, format) {
      if (date) {
        console.log(date);
        return moment(date).format(format);
      }
    },
    cancel() {
      this.datePicker = "";
      this.timePicker = "";
      this.dialog = false;
    },
    onDateSelected() {
      this.$emit(
        "onDateSelected",
        this.dateStringToDate(this.datePicker + " " + this.timePicker)
      );
      this.dialog = false;
    },
    dateStringToDate(dbDateString) {
      if (typeof dbDateString !== "string") {
        return dbDateString;
      }
      return new Date(dbDateString.replace(/-/g, "-").replace(/\..*$/, ""));
    },
  },
};
</script>

<style>
</style>